import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyFieldVisits extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={true} pageTitle={"Field Visits" } formname={"table_76"} customClass={"field-customization-container"} />
        );
    }
}

export default LegacyFieldVisits;